module.exports = __webpack_public_path__ + "assets/webgl/art_052_L0.jpg.pvr.640c290f.ktx";